import {ToggleScroll} from "@main/components/toggle-scroll";

class VideoModal {
    modal = document.querySelector(".js-video-modal");
    playVideoBtn = this.modal.querySelector(".js-play-video");
    closeVideoBtn = this.modal.querySelector(".js-close-video-btn");
    video = this.modal.querySelector(".js-video");
    videoIframe = this.modal.querySelector(".js-video-iframe");
    overlay = this.modal.querySelector(".js-overlay");
    videoYoutubeIframe = null;
    youtube = this.modal.querySelector(".js-youtube");
    youtubeBlock = this.youtube?.querySelector(".js-youtube-block");

    constructor(el) {
        this.el = el;
        this.showVideoBtn = this.el.querySelector(".js-show-video-btn");
        this.documentEl = document.body;
        this.isPlaying = false;

        this.createPosterForVideo();
        this.listenEvents();

        if (document.querySelectorAll(".js-video-wrapper").length === 1) {
            this.setVideoId();
        }
    }

    listenEvents() {
        this.showVideoBtn.addEventListener("click", () => {
            this.setVideoId();

            if (this.el.dataset.video) {
                this.video.src = this.el.dataset.video;
            }
            
            if (this.showVideoBtn.dataset.video) {
                this.videoIframe.src = this.showVideoBtn.dataset.video;
            }

            this.modal.classList.add("shown");
            ToggleScroll.disable(this.modal);
            if(this.youtube.dataset?.autoplay === "true") {
                this.createYoutubeVideo();
            }
        });

        this.playVideoBtn?.addEventListener("click", this.playVideoBtnClickHandler);
        this.video?.addEventListener("play", () => this.playVideoBtn.classList.remove("shown"));
        this.video?.addEventListener("pause", () => this.playVideoBtn.classList.add("shown"));
        this.closeVideoBtn.addEventListener("click", this.onCloseVideoModal.bind(this));
        this.overlay.addEventListener("click", this.onCloseVideoModal.bind(this));

        window.addEventListener("webkitfullscreenchange", this.onFullScreenChangeHandler);
        window.addEventListener("mozfullscreenchange", this.onFullScreenChangeHandler);
        window.addEventListener("fullscreenchange", this.onFullScreenChangeHandler);

        this.youtube.addEventListener("click", this.createYoutubeVideo.bind(this));
    }

    setVideoId() {
        if(this.showVideoBtn.hasAttribute("data-videoid")) {
            this.videoId = this.showVideoBtn.getAttribute("data-videoid");
            this.youtube.setAttribute("data-embed", this.videoId);
            this.createPosterForVideo();
        }
    }

    /**
     * Создаем iframe c видео с youtube / vk
     *
     * @returns {void}
     */
    createYoutubeVideo() {
        let iframe = document.createElement("iframe");
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("allowfullscreen", "");
        iframe.setAttribute("allow", "clipboard-write; autoplay");

        if(this.youtube.dataset?.source === "vk") {
            iframe.setAttribute("src", this.youtube.dataset.embed + "&autoplay=1?volume=50");
        } else {
            iframe.setAttribute("src", "https://rutube.ru/play/embed/"+
            this.showVideoBtn.dataset.embed +"?rel=0&showinfo=0&autoplay=1" );
        }

        this.youtubeBlock.innerHTML = "";
        this.youtubeBlock.appendChild(iframe);
        this.playVideoBtn.classList.remove("shown");
        this.videoYoutubeIframe = iframe;
    }

    /**
     * Создаём картинку-превью для видео и делаем видимой кнопку play
     *
     * @returns {void}
     */
    createPosterForVideo() {
        if(!this.modal.classList.contains("js-uk-club-modal")) {
            const source = "https://rutube.ru/api/video/"+ this.youtube.dataset.embed +"/thumbnail/?redirect=1";

            const image = new Image();
            image.src = source;
            image.addEventListener("load", () => {
                this.youtubeBlock.appendChild(image);
                this.playVideoBtn.classList.add("shown");
            });
        }
    }

    /**
     * Запуск/остановка видео и скрытие/возвращение кнопки Play
     *
     * @returns {void}
     */
    playVideoBtnClickHandler = () => {
        if(this.video) {
            if (this.isPlaying) {
                this.isPlaying = false;
                this.video.pause();
                this.playVideoBtn.classList.add("shown");
            } else {
                this.isPlaying = true;
                this.video.play();
                this.playVideoBtn.classList.remove("shown");
            }
        }
    };

    onFullScreenChangeHandler = (e) => {
        if (this.video.contains(e.target) && !this.video.classList.contains("fullscreen")) {
            this.video.classList.add("fullscreen");
        } else {
            this.video.classList.remove("fullscreen");
        }
    };

    /**
     * Действия при закрытии модала с видео.
     * Если через тег video - видео ставится на паузу.
     * Если через iframe - удаляем его и вновь создаем постер к видео.
     * 
     * @returns {void} 
     */
    onCloseVideoModal() {
        if (this.video) {
            this.video.pause();
        } else {
            if(this.videoYoutubeIframe) {
                this.videoYoutubeIframe = this.modal.querySelectorAll("iframe")[0];
                this.videoYoutubeIframe.remove();
            }
            this.createPosterForVideo();
        }
    }
}

window.addEventListener("load", () => {
    document.querySelectorAll(".js-video-wrapper").forEach((item) => new VideoModal(item));
});
